import { Link } from 'react-router';
import type { TicketDetail } from '../../../api/ticket-types';
import { Badge, StateBadge, humanize } from '../../../ui/Badge';
import { ActorName, Card } from '../../../ui/misc';
import { Timestamp } from '../../../ui/Timestamp';

export function Approvals({ t }: { t: TicketDetail }) {
  return (
    <>
      <Card title="Acceptance decisions" subtitle="Authenticated admin decisions for exact scope revisions.">
        {t.acceptances.length === 0 ? (
          <span className="small muted">Not accepted yet.</span>
        ) : (
          <ul className="checklist">
            {t.acceptances.map((a) => (
              <li key={a.id} className="small" style={{ justifyContent: 'space-between' }}>
                <span>
                  <span className="mono">{a.displayId}</span> · revision {a.scopeRevision} · accepted by{' '}
                  <ActorName actor={a.admin} /> (
                  {a.requestOrigin === 'agent' || a.requestOrigin === 'mcp'
                    ? 'requested by an agent'
                    : 'directly in the app'}
                  ) · <Timestamp value={a.createdAt} />
                </span>
                {a.revokedAt ? (
                  <Badge>Revoked: {a.revokedReason}</Badge>
                ) : a.current ? (
                  <Badge tone="success">Current</Badge>
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </Card>
      <Card title="Approval requests">
        {t.approvals.length === 0 ? (
          <span className="small muted">No requests.</span>
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Request</th>
                  <th>Intent</th>
                  <th>Requester</th>
                  <th>State</th>
                  <th>Decided by</th>
                </tr>
              </thead>
              <tbody>
                {t.approvals.map((a) => (
                  <tr key={a.id}>
                    <td>
                      <Link to={`/approvals/${a.displayId}`} className="mono">
                        {a.displayId}
                      </Link>
                    </td>
                    <td>
                      {humanize(a.intent)} · rev {a.targetRevision}
                    </td>
                    <td>
                      <ActorName actor={a.requester} />
                    </td>
                    <td>
                      <StateBadge state={a.state} />
                    </td>
                    <td>
                      <ActorName actor={a.decidedBy} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </>
  );
}
